/**
 * @ngdoc service
 * @name image
 *
 * @description
 * Service used to load pictures.
 */
module.factory('image', function ($http, $q, $window, lodash, drupal) {

    function whenvisible(element) {
        var def = $q.defer();

        function isVisible() {
            if (document.body.contains(element[0])) {
                var rect = element[0].getBoundingClientRect();
                var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                var visible = !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                if (visible) {
                    angular.element($window).off('resize', check);
                    angular.element($window).off('scroll', check);
                    def.resolve();
                }
            }
            else {
                angular.element($window).off('resize', check);
                angular.element($window).off('scroll', check);
                def.reject();
            }
        }

        var check = lodash.throttle(isVisible, 300);

        angular.element($window).on('resize', check);
        angular.element($window).on('scroll', check);

        isVisible();

        return def;
    }

    return {
        whenVisible: function (element) {
            var def = $q.defer();

            function isVisible() {
                if (document.body.contains(element[0])) {
                    var rect = element[0].getBoundingClientRect();
                    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    var visible = !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                    if (visible) {
                        angular.element($window).off('resize', check);
                        angular.element($window).off('scroll', check);
                        def.resolve();
                    }
                }
                else {
                    angular.element($window).off('resize', check);
                    angular.element($window).off('scroll', check);
                    def.reject();
                }
            }

            var check = lodash.throttle(isVisible, 300);

            angular.element($window).on('resize', check);
            angular.element($window).on('scroll', check);

            isVisible();

            return def;
        },
        load: function (element, uri) {
            var def = $q.defer();
            if (uri && uri.length > 0) {
                // Image absolute url
                var url = uri.indexOf('http') === 0 ? uri : (drupal.getResourcePath(uri) + uri);
                // Image preloading
                angular
                    .element(new Image())
                    .on('load', function () {
                        def.resolve(url);
                    })
                    .on('error', function (e) {
                        def.reject();
                    })
                    .prop('src', url);
            }
            else {
                def.reject();
            }
            return def.promise;
        }
    }
});
